export const DASHBOARD_V2_ROLLOUT = 'dashboard_v2_rollout';
export const DASHBOARD_V2_VARIANT = 1;
export const PREFERENCES_THIRD_PLAN_EXPERIMENTS = [
  'preferences_third_plan',
  'preferences_third_plan_new',
];

export const PREFERENCES_THIRD_PLAN_VARIANTS = [1, 2];
